// Sarvam AI API client — STT and TTS via MCP server proxy
import { fetchClientConfig } from './auth';

let _mcpBaseUrl = process.env.REACT_APP_MCP_API_URL?.replace('/call', '') || 'https://core.yantrai.com/mcp';
let _configFetched = false;

async function ensureBaseUrl(): Promise<string> {
  if (!_configFetched) {
    try {
      const cfg = await fetchClientConfig();
      if (cfg.mcp_api_url) _mcpBaseUrl = cfg.mcp_api_url.replace('/call', '');
    } catch {
      // fall back
    }
    _configFetched = true;
  }
  return _mcpBaseUrl;
}

export interface STTResult {
  text: string;
  original_text: string;
  detected_language: string;
}

export async function speechToText(audioBlob: Blob): Promise<STTResult> {
  const baseUrl = await ensureBaseUrl();
  const formData = new FormData();
  formData.append('audio', audioBlob, 'recording.webm');

  const resp = await fetch(`${baseUrl}/stt`, {
    method: 'POST',
    body: formData,
  });

  if (!resp.ok) throw new Error(`STT failed: ${resp.status}`);
  return resp.json();
}

export async function textToSpeech(
  text: string,
  language: string,
  speaker: string = 'meera'
): Promise<Blob> {
  const baseUrl = await ensureBaseUrl();
  const resp = await fetch(`${baseUrl}/tts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, language, speaker }),
  });

  if (!resp.ok) throw new Error(`TTS failed: ${resp.status}`);
  return resp.blob();
}
